import React from "react";
import { Filters, Select } from "./design";

const TaskFilters = ({ houses, selectedHouse, setSelectedHouse, statusFilter, setStatusFilter }) => (
    <Filters>
        <Select aria-label="Haus" value={selectedHouse} onChange={e => setSelectedHouse(e.target.value)}>
            <option value="">Alle Häuser</option>
            {houses.map(house => <option key={house} value={house}>{house}</option>)}
        </Select>
        <Select aria-label="Status" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
            <option value="all">Alle Aufgaben</option>
            <option value="open">Offen</option>
            <option value="done">Erledigt</option>
        </Select>
    </Filters>
);
export default TaskFilters;
